import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { get_category_menu_setup } from '../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { ReactCropperImageUpload } from '../../../../../../../reusableComponents/imageUploadReusableComponent/ReactCropperImageUpload';
import { NewInputText } from '../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import { AddButtonIconComponent } from '../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent';
import SVG from 'react-inlinesvg';

function BasicInformation({ formik, menu }) {
  const [keywords, setKeywords] = useState(formik?.values?.keywords || []);
  const [keywordsText, setKeywordsText] = useState('');
  const [errors, setErrors] = useState({});

  const onCompleteUpload = (files, thumbnails) => {
    formik.setFieldValue('images', [...formik.values.images, ...files]);
    formik.setFieldValue('image_thumbnails', [
      ...formik.values.image_thumbnails,
      ...thumbnails,
    ]);
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.images.filter((item, index) => {
      return index !== indexId;
    });
    let thumbImage = formik.values.image_thumbnails.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue('images', allImages);
    formik.setFieldValue('image_thumbnails', thumbImage);
  };

  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      let keywordsTextVr = keywordsText;
      let keywordsArr = keywords;
      if (keywordsTextVr === '') {
        errors.keywordsTextVr = 'Keywords is Required';
        setErrors({
          errors: errors,
        });
      } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
        alert('Keywords Already Exits');
      } else {
        keywordsArr.push(keywordsTextVr);
        setKeywords(keywordsArr);
        formik.setFieldValue('keywords', keywordsArr);
        setKeywordsText('');
      }
    }
  };
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
    formik.setFieldValue('keywords', data);
  };

  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === '') {
      errors.keywordsTextVr = 'Keywords is Required';
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert('Keywords Already Exits');
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      formik.setFieldValue('keywords', keywords);
      setKeywordsText('');
    }
  };
  useEffect(() => {
    // Only update keywords if they are different from the current state
    if (formik?.values?.keywords && formik.values.keywords !== keywords) {
      setKeywords(formik.values.keywords);
    }
  }, [formik.values.keywords, keywords]);

  return (
    <div>
      <Form>
        <Form.Label className="f14-500 mb-3">Assign Category</Form.Label>
        <div>
          <Row>
            <Col md={6}>
              <FormControl variant="outlined" className={'w-100'}>
                <InputLabel id="demo-simple-select-label-From">
                  Category
                </InputLabel>
                <Select
                  label="Category"
                  value={formik.values.category_id || ''}
                  onChange={(event) => {
                    const selectedMenu = menu?.find(
                      (ele) => ele._id === event.target.value
                    );

                    formik.setFieldValue('category_id', event.target.value);
                    formik.setFieldValue(
                      'categoryName',
                      selectedMenu?.name || ''
                    );
                  }}
                  name="category_id"
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {menu?.map((ele) => (
                    <MenuItem value={ele._id} key={ele._id}>
                      {ele.name}
                    </MenuItem>
                  ))}
                </Select>

                {formik.errors.category_id && formik.touched.category_id ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.category_id}
                  </div>
                ) : null}
              </FormControl>
              <div>
                <Form.Label className="f14-500 my-3">Add Combo Name</Form.Label>

                <TextField
                  id="comboName"
                  label="Combo Name"
                  type="text"
                  variant="outlined"
                  className={`w-100 ${
                    formik.errors.comboName && formik.touched.comboName
                      ? 'enError'
                      : ''
                  }`}
                  name="comboName"
                  helperText={
                    formik.errors.comboName && formik.touched.comboName
                      ? formik.errors.comboName
                      : 'Max 60 characters'
                  }
                  onChange={formik.handleChange}
                  value={formik.values.comboName}
                  onBlur={formik.handleBlur}
                  //disabled={pathName.includes('edit')}
                  error={formik.errors.comboName && formik.touched.comboName}
                  isInvalid={
                    formik.errors.comboName && formik.touched.comboName
                  }
                />
              </div>
              <div>
                <Row>
                  <Col md={10} className="mt-3">
                    <div className=" onboarding-restaurant-details-margin">
                      <div className="row align-items-center">
                        <div className="col-9">
                          <NewInputText
                            extraClass="mb-1"
                            name="keywordsText"
                            onChange={onKeywordsChangeHandler}
                            value={keywordsText}
                            labelText="Keywords"
                            inputType="text"
                            onKeyPress={(e) => {
                              if (e.which == 13) {
                                e.preventDefault();
                              }
                            }}
                            onKeyDown={handleKeyDown}
                          />
                          <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                            {errors.keywordsText}
                          </div>
                          <div className="opacity5 f10-400">
                            (Your keywords for the food item will help people
                            find the item with ease )
                          </div>
                        </div>
                        <div className="col-3">
                          <AddButtonIconComponent
                            buttonText="Add Keywords"
                            onClick={addKeywordsAction}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={8} className="mt-3">
                    {keywords && keywords?.length > 0 ? (
                      <div className="col-12 p-0 onboarding-restaurant-details-margin">
                        <div className="row enChipBox border-0">
                          {/* <Scrollbars
                                  style={{ width: "100%", height: 135 }}
                                > */}
                          {keywords &&
                            keywords.map((data, index) => {
                              return (
                                <div className="mb-3 mr-3" key={index}>
                                  <div className="keywords_button">
                                    <p>{data}</p>
                                    <span
                                      className="ml-2"
                                      onClick={removeKeywordsAction(index)}
                                    >
                                      <SVG
                                        src={require('../../../../../../../../assets/images/UserManagement/close.svg')}
                                      />
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          {/* </Scrollbars> */}
                        </div>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </div>
              <div>
                <Form.Label className="f14-500 my-3">Description</Form.Label>

                <TextField
                  id="description"
                  label="Description"
                  type="text"
                  variant="outlined"
                  multiline
                  rows="5"
                  className={`w-100 ${
                    formik.errors.description && formik.touched.description
                      ? 'enError'
                      : ''
                  }`}
                  name="description"
                  helperText={
                    formik.errors.description && formik.touched.description
                      ? formik.errors.description
                      : 'Max 1500 characters'
                  }
                  onChange={formik.handleChange}
                  value={formik.values.description}
                  onBlur={formik.handleBlur}
                  //disabled={pathName.includes('edit')}
                  error={
                    formik.errors.description && formik.touched.description
                  }
                  isInvalid={
                    formik.errors.description && formik.touched.description
                  }
                />
              </div>
              <div className="my-2">
                <div className="event-offer-image">
                  <ReactCropperImageUpload
                    title="Add Photo *"
                    smallTitle=""
                    onComplete={onCompleteUpload}
                    value={formik.values.images}
                    removeImage={bankDocMultipleRemove}
                    maxImageSize={500000}
                  />
                </div>{' '}
                {formik.errors.images && formik.touched.images ? (
                  <div className="mb-3 pho_14_regular text-danger">
                    {formik.errors.images}
                  </div>
                ) : (
                  <div className="mb-3"> </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}

// BasicInformation.propTypes = {
//   auth: PropTypes.object.isRequired,
//   get_category_menu_setup: PropTypes.func.isRequired,
//   customMenuList: PropTypes.object.isRequired,
//   ActiveMenu: PropTypes.object.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
//   errors: state.errors && state.errors.errors,
//   menuCategory: state.onboarding && state.onboarding.menuCategory,

//   onboarding: state.onboarding && state.onboarding,
// });

// export default connect(mapStateToProps, {
//   get_category_menu_setup,
// })(BasicInformation);
export default BasicInformation;
